import { qs } from "@fluorescent/dom";
import {
  FadeUpReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  fadeUp: ".animation-fade-up-reveal",
};

export default node => {
  let observer = null;
  const fadeUpItem = qs(selectors.fadeUp, node);
  let reveal = null;

  if (shouldAnimate(node)) {
    // Initialize animations and intersection observer
    reveal = new FadeUpReveal(fadeUpItem);

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    reveal.play();
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
